import { GridComparatorFn } from '@mui/x-data-grid-pro';
import { compareSemvers } from '@bymason/utils';

export const dataGridSemverCompare: GridComparatorFn = (v1 = '', v2 = '') => {
  if (typeof v1 === 'string' && typeof v2 === 'string') {
    return compareSemvers(v1, v2);
  } else {
    throw 'Invalid semantic version: comparator only accepts strings';
  }
};
